module.exports = ".container {\n  padding: 20px 30px;\n  margin-left: auto;\n  margin-right: auto; }\n  .container h1 {\n    color: #666666;\n    font-family: Roboto;\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 40px;\n    margin: 0 0 20px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shipments/components/track/track.component.scss
// module id = ./src/app/modules/shipments/components/track/track.component.scss
// module chunks = main